
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iao-valley/about",
      function () {
        return require("private-next-pages/iao-valley/about.js");
      }
    ]);
  